import {
  GET_APPOINTMENTS,
  GET_APPOINTMENTS_FAILURE,
  GET_APPOINTMENTS_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getAppointmentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_APPOINTMENTS:
      return { ...state, loading: true };
    case GET_APPOINTMENTS_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_APPOINTMENTS_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getAppointmentsReducer;
